export default "__VITE_ASSET__BIsZg9Vn__"